import { Toast } from 'vant'
import { getEntryInfo } from '@/utils'
import { wechatSignatureInfo } from '@/apis/wx'
import { judgeIsLocalDevEnv } from '@/utils/index'
import { getQueryStringArgs } from '@/utils/tools'
import wx from 'weixin-js-sdk'
import { userEntryUrlStorage } from '@/storage/common'

export interface NavigationInfo {
  address: string
  lng: number
  lat: number
}

function checkIsWeixin(): boolean {
  return navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1
}

/**
 * 依赖于【极飞会员】小程序
 */
const PHONE_PAGE = '/pages--user/phone'
const PAGE_PAGE = '/pages/user/pay'
const OPENPDF_PAGE = '/pages/user/openFile'
const ua = navigator.userAgent.toLowerCase()
class Controller {
  requestUrl: string
  hasConfig: boolean
  configing: boolean
  debugger = false
  resolveList: Array<(value: unknown) => void>
  isWeixin: boolean
  _isMiniprogram: boolean // 判断运行环境是不是小程序内 通过jssdk判断
  _isMockMiniprogram = false // 模拟是不是小程序内 通过外部设置
  _time: number
  _entryUrl = ''
  _isIos = false
  relogined = false

  constructor() {
    this.isWeixin = checkIsWeixin()
    this.resolveList = []
    this._isIos =
      !!window.__wxjs_is_wkwebview || ua.indexOf('iphone') !== -1 || ua.indexOf('ipad') !== -1
    const ready = () => {
      this._isMiniprogram = window.__wxjs_environment === 'miniprogram'
      this.debugger && Toast('wx.isMiniprogram' + this._isMiniprogram)
    }
    if (!window.WeixinJSBridge || !window.WeixinJSBridge.invoke) {
      document.addEventListener('WeixinJSBridgeReady', ready, false)
    } else {
      ready()
    }
    this.resetInit()
  }
  /**
   * 每个方法调用前，都config一次
   * 在config里会根据url是否发生变化来判断
   * @returns
   */
  resetInit() {
    wx.ready(() => {
      this.debugger && Toast('wx.ready')
      while (this.resolveList.length) {
        const resolve = this.resolveList.pop()
        resolve && resolve(1)
      }
    })
    wx.error((res) => {
      console.log('wx.error')
      // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      Toast(this._isIos + '|wx|' + res.errMsg)
    })
  }
  config() {
    console.log('this._isIos', this._isIos)
    if (this._isIos && this._entryUrl === '') {
      console.log('userEntryUrlStorage.get()', userEntryUrlStorage.get())
      this._entryUrl = userEntryUrlStorage.get() || window.location.href.split('#')[0]
    }
    return new Promise((resolve) => {
      let requestUrl = window.location.href
      if (this._isIos && this._entryUrl !== '') {
        requestUrl = this._entryUrl
      }
      if (requestUrl !== this.requestUrl) {
        this.resolveList.length = 0
        this._time = Date.now()
        this.hasConfig = false
        this.configing = false
      }
      if (this.hasConfig) return resolve(1)
      this.resolveList.push(resolve)
      if (this.configing) return
      const __time = this._time
      this.configing = true
      this.requestUrl = requestUrl
      wechatSignatureInfo(requestUrl).then((config) => {
        console.log('requestUrl', requestUrl, config)
        if (__time !== this._time) return
        this.resetInit()
        console.log('wxConfig', config)
        wx.config(config)
        this.hasConfig = true
        this.configing = false
      })
    })
  }
  get isMiniprogram() {
    return this._isMiniprogram || this._isMockMiniprogram
  }
  /**
   * 跳转小程序来发起支付
   * @param orderNum - 订单号
   */
  async onPay(orderNum: string | number) {
    console.log('onPay', orderNum)
    await this.config()
    if (!this.isMiniprogram) return
    const url = `${PAGE_PAGE}?guid=${orderNum}`
    wx.miniProgram.navigateTo({
      url,
    })
  }
  /**
   * 跳转到小程序来拨打电话
   * @param options
   */
  async postCallPhone(phone: string, name?: string, title?: string) {
    console.log('postCallPhone', phone, name, title)
    await this.config()
    if (!this.isMiniprogram) return
    let url = `${PHONE_PAGE}?phone=${encodeURIComponent(phone)}`
    if (name) {
      url += `&name=${encodeURIComponent(name)}`
    }
    if (title) {
      url += `&title=${encodeURIComponent(title)}`
    }
    wx.miniProgram.navigateTo({
      url,
    })
  }
  /**
   * 拉起导航
   * @param obj
   */
  async postMapNavigation(obj: NavigationInfo) {
    console.log('postMapNavigation', obj)
    await this.config()
    this.debugger && Toast('openLocation')
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this
    wx.openLocation({
      latitude: obj.lat,
      longitude: obj.lng,
      address: obj.address,
      name: '',
      scale: 10,
      infoUrl: '',
      success() {
        vm.debugger && Toast('openLocation:success')
      },
      fail(e) {
        vm.debugger && Toast(JSON.stringify(e))
      },
    })
  }
  async startLocation(status: boolean, cb?: (lng: number, lat: number) => void) {
    console.log('startLocation', status, cb)
    await this.config()
    this.debugger && Toast('getLocation')
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this
    wx.getLocation({
      type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
      success(res) {
        console.log('res', res)
        vm.debugger && Toast('getLocation:success')
        cb(res.longitude, res.latitude)
      },
      fail(res) {
        console.log('fail', res)
        const EntryData = getEntryInfo()
        if (EntryData.lng) {
          cb(parseFloat(EntryData.lng), parseFloat(EntryData.lat))
        }
        vm.debugger && Toast(JSON.stringify(res))
      },
    })
  }
  async startlocationPromise(): Promise<number[]> {
    // 本地开发环境判断，如果是本地开发则返回默认经纬度
    if (judgeIsLocalDevEnv()) {
      console.log('本地开发环境，返回默认经纬度: [113.23, 23.16]')
      return [113.23, 23.16]
    }
    await this.config()
    return new Promise((resolve, reject) => {
      wx.getLocation({
        type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success(res) {
          console.log('res', res)
          resolve([res.longitude, res.latitude])
        },
        fail(res) {
          console.log('fail', res)
          const EntryData = getEntryInfo()
          if (EntryData.lng) {
            resolve([parseFloat(EntryData.lng), parseFloat(EntryData.lat)])
          }
          reject(res)
        },
      })
    })
  }
  async redirectTo(url: string) {
    wx.miniProgram.redirectTo({
      url,
    })
  }
  relogin() {
    if (this.relogined) {
      return
    }
    this.relogined = true
    // 在小程序环境下调用小程序进行重新登陆的功能
    // console.log('222', '/pages/login?goto=' + encodeURIComponent(window.location.href))
    const query = getQueryStringArgs(window.location.href)
    delete query.mini
    delete query.token
    let queryString = ''
    if (Object.keys(query).length) {
      queryString =
        '?' +
        Object.keys(query)
          .reduce((result, key) => {
            result = result.concat(`${key}=${query[key]}`)
            return result
          }, [])
          .join('&')
    }
    const url = location.origin + location.pathname + queryString
    wx.miniProgram.redirectTo({
      url: '/pages--account/login?goto=' + encodeURIComponent(url),
    })
  }
  postMessage<T>(data: T) {
    wx.miniProgram.postMessage({
      data,
    })
  }
  /**
   * 跳转小程序打开文件
   * @param filePath - 文件地址
   */
  async onOpenFile(filePath: string, isImg = false) {
    console.log('onOpenfile', filePath)
    await this.config()
    if (!this.isMiniprogram) return
    let url = `${OPENPDF_PAGE}?url=${encodeURIComponent(filePath)}`
    if (isImg) {
      url += `&isImg=true`
    }
    wx.miniProgram.navigateTo({
      url,
    })
  }
  /**
   * 小程序前往某页面
   * @param url - 小程序页面路径
   */
  async navigateTo(url: string) {
    console.log('navigateTo', url)
    wx.miniProgram.navigateTo({
      url,
    })
  }
}

export default new Controller()
